import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../../../services/hmi-lookup.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'bakim-talebi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bt-edit">
      <div class="bt-baslik">
        <div class="bt-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
          </svg>
        </div>
        <span>Bakım Talebi Bilgileri</span>
      </div>

      <div class="bt-form">
        <div class="form-grup">
          <label>Makine <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.makine"
              (ngModelChange)="guncelle('makine', $event)"
              nzPlaceHolder="Makine seçin..."
              nzAllowClear nzShowSearch nzServerSearch
              (nzOnSearch)="lookup.makineleriYukle($event)"
              (nzOpenChange)="$event && lookup.makineleriYukle()"
              style="width:100%"
              [nzCustomTemplate]="makineTpl">
              @for (m of lookup.makineler(); track m._id) {
                <nz-option [nzValue]="m.makineAdi" [nzLabel]="m.makineAdi" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">⚙️</span><div class="sel-bilgi"><span class="sel-ad">{{ m.makineAdi }}</span><span class="sel-detay">{{ m.makineKodu || '' }}{{ m.tip ? ' · ' + m.tip : '' }}</span></div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #makineTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">⚙️</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Arıza Türü</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.arizaTuru"
              (ngModelChange)="guncelle('arizaTuru', $event)"
              nzPlaceHolder="Arıza türü seçin..."
              nzAllowClear
              style="width:100%"
              [nzCustomTemplate]="arizaTuruTpl">
              <nz-option nzValue="Mekanik" nzLabel="Mekanik" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Mekanik</span></div>
              </nz-option>
              <nz-option nzValue="Elektrik" nzLabel="Elektrik" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#3b82f6"></span><span class="sel-ad">Elektrik</span></div>
              </nz-option>
              <nz-option nzValue="Hidrolik" nzLabel="Hidrolik" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#06b6d4"></span><span class="sel-ad">Hidrolik</span></div>
              </nz-option>
              <nz-option nzValue="Pnömatik" nzLabel="Pnömatik" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#8b5cf6"></span><span class="sel-ad">Pnömatik</span></div>
              </nz-option>
              <nz-option nzValue="Yazılım" nzLabel="Yazılım" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#10b981"></span><span class="sel-ad">Yazılım</span></div>
              </nz-option>
              <nz-option nzValue="Diğer" nzLabel="Diğer" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#6b7280"></span><span class="sel-ad">Diğer</span></div>
              </nz-option>
            </nz-select>
            <ng-template #arizaTuruTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="arizaTuruRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="bt-ayirici"></div>

        <div class="form-grup">
          <label>Aciliyet</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.aciliyet"
              (ngModelChange)="guncelle('aciliyet', $event)"
              nzPlaceHolder="Aciliyet seviyesi..."
              nzAllowClear
              style="width:100%"
              [nzCustomTemplate]="aciliyetTpl">
              <nz-option nzValue="Düşük" nzLabel="Düşük" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#94a3b8"></span><span class="sel-ad">Düşük</span></div>
              </nz-option>
              <nz-option nzValue="Orta" nzLabel="Orta" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Orta</span></div>
              </nz-option>
              <nz-option nzValue="Yüksek" nzLabel="Yüksek" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#ef4444"></span><span class="sel-ad">Yüksek</span></div>
              </nz-option>
              <nz-option nzValue="Acil Durum" nzLabel="Acil Durum" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#7f1d1d"></span><span class="sel-ad">Acil Durum</span></div>
              </nz-option>
            </nz-select>
            <ng-template #aciliyetTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="aciliyetRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="bt-ayirici"></div>

        <div class="form-grup">
          <label>Açıklama <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.aciklama || ''"
              (ngModelChange)="guncelle('aciklama', $event)"
              placeholder="Arıza veya bakım detayını açıklayın..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="3" [cdkAutosizeMaxRows]="6">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Durum</label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.durum || 'Bekliyor'" (ngModelChange)="guncelle('durum', $event)" style="width:100%"
              [nzCustomTemplate]="durumTpl">
              <nz-option nzValue="Bekliyor" nzLabel="Bekliyor" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#94a3b8"></span><span class="sel-ad">Bekliyor</span></div>
              </nz-option>
              <nz-option nzValue="İnceleniyor" nzLabel="İnceleniyor" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#3b82f6"></span><span class="sel-ad">İnceleniyor</span></div>
              </nz-option>
              <nz-option nzValue="Onarılıyor" nzLabel="Onarılıyor" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Onarılıyor</span></div>
              </nz-option>
              <nz-option nzValue="Tamamlandı" nzLabel="Tamamlandı" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#22c55e"></span><span class="sel-ad">Tamamlandı</span></div>
              </nz-option>
            </nz-select>
            <ng-template #durumTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="btDurumRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Rapor Eden</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.raporEden"
              (ngModelChange)="guncelle('raporEden', $event)"
              nzPlaceHolder="Rapor eden kişi..."
              nzAllowClear nzShowSearch
              style="width:100%"
              [nzCustomTemplate]="raporEdenTpl">
              @for (per of lookup.personeller(); track per._id) {
                <nz-option [nzValue]="per.ad + ' ' + per.soyad" [nzLabel]="per.ad + ' ' + per.soyad" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">👤</span><div class="sel-bilgi"><span class="sel-ad">{{ per.ad }} {{ per.soyad }}</span><span class="sel-detay">{{ per.unvan || per.gorev || '' }}{{ per.sicilNo ? ' · ' + per.sicilNo : '' }}</span></div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #raporEdenTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">👤</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .bt-edit {
      display: flex;
      flex-direction: column;
      gap: 0;
      padding: 0;
    }

    .bt-baslik {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 16px;
      margin-bottom: 4px;
      border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .bt-baslik-ikon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #dc2626, #ef4444);
      color: #fff;
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);
      position: relative;
    }

    .bt-baslik-ikon::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%;
      animation: shimmer 3s infinite linear;
      pointer-events: none;
    }

    .bt-baslik span {
      font-size: 13px;
      font-weight: 600;
      color: var(--py-metin, #333);
      letter-spacing: 0.3px;
    }

    .bt-form {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 4px 2px;
    }

    .bt-ayirici {
      height: 1px;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
      opacity: 0.4;
      margin: 2px 0;
    }

    .form-grup {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .form-grup label {
      font-size: 11px;
      font-weight: 500;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45));
      text-transform: uppercase;
      letter-spacing: 0.6px;
      padding-left: 2px;
      transition: color 0.2s ease;
    }

    .form-grup:focus-within label {
      color: var(--py-link, #1890ff);
    }

    .zorunlu {
      color: #ff4d4f;
      font-size: 13px;
      line-height: 1;
      vertical-align: middle;
    }

    .input-wrap {
      position: relative;
    }

    .input-glow {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      border-radius: 1px;
      background: linear-gradient(90deg, #dc2626, #f59e0b, #dc2626);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1),
                  left 0.35s cubic-bezier(0.4, 0, 0.2, 1),
                  opacity 0.3s ease;
      opacity: 0;
      pointer-events: none;
      z-index: 1;
    }

    .input-wrap:focus-within .input-glow {
      width: 100%;
      left: 0;
      opacity: 1;
    }

    .input-wrap input[nz-input],
    .input-wrap textarea[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9);
      border-radius: 8px;
      padding: 8px 12px;
      font-size: 13px;
      color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover,
    .input-wrap textarea[nz-input]:hover {
      border-color: var(--py-kenarlik-hover, #b3b3b3);
      background: var(--py-arkaplan-hover, #f5f5f5);
    }

    .input-wrap input[nz-input]:focus,
    .input-wrap textarea[nz-input]:focus {
      border-color: var(--py-kenarlik-aktif, #1890ff);
      background: var(--py-input-arka, #fff);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      outline: none;
    }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important;
      border-radius: 8px !important;
      min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-hover, #b3b3b3) !important;
      background: var(--py-arkaplan-hover, #f5f5f5) !important;
    }

    .input-wrap:focus-within ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-aktif, #1890ff) !important;
      background: var(--py-input-arka, #fff) !important;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important;
    }

    @keyframes shimmer {
      0% { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
  `],
})
export class BakimTalebiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);

  constructor() { super(); this.lookup.personelleriYukle(); this.lookup.makineleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  arizaTuruRenk(v: string): string {
    const m: Record<string, string> = { 'Mekanik': '#f59e0b', 'Elektrik': '#3b82f6', 'Hidrolik': '#06b6d4', 'Pnömatik': '#8b5cf6', 'Yazılım': '#10b981', 'Diğer': '#6b7280' };
    return m[v] || '#6b7280';
  }

  btDurumRenk(v: string): string {
    const m: Record<string, string> = { 'Bekliyor': '#94a3b8', 'İnceleniyor': '#3b82f6', 'Onarılıyor': '#f59e0b', 'Tamamlandı': '#22c55e' };
    return m[v] || '#94a3b8';
  }

  aciliyetRenk(v: string): string {
    switch (v) {
      case 'Düşük': return '#94a3b8';
      case 'Orta': return '#f59e0b';
      case 'Yüksek': return '#ef4444';
      case 'Acil Durum': return '#7f1d1d';
      default: return '#94a3b8';
    }
  }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }
}
